import { render, staticRenderFns } from "./EvaluationBtn.vue?vue&type=template&id=5e3f59d8&scoped=true"
import script from "./EvaluationBtn.vue?vue&type=script&lang=js"
export * from "./EvaluationBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3f59d8",
  null
  
)

export default component.exports